
import React from 'react';
import { GAHeaderClickSignUp, GAHeaderClickLogout, GAHeaderClickLogin, GAHeaderClickToPersonCenter } from '@/ga/header';
import { Link } from "react-router-dom";
import './index.less';
import Cookies from 'js-cookie';

const Header = ({ handleLogout }) => {
  const hostname = window.location.origin;

  return (
    <>
      <div id="sidebar">
        <div className="aside-tel aside-item position-relative">
          <img alt="" src="https://images.niuxuezhang.cn/imgs/home/phone.png" className="lozad img-fluid" data-loaded="true" />
          <div className="phone position-absolute d-none bg-white position-relative">
            <div className="small fw-bold" style={{ lineHeight: '24px' }}>客服电话</div>
            <div className="text-primary fw-bold small" style={{ lineHeight: '24px' }}>191 2998 3917</div>
          </div>
        </div>
        <div className="aside-email aside-item position-relative">
          <img alt="" src="https://images.niuxuezhang.cn/imgs/home/email.png" className="lozad img-fluid" data-loaded="true" />
          <div className="position-absolute d-none bg-white email position-relative">
            <div className="small fw-bold" style={{ lineHeight: '24px' }}>客服邮箱</div>
            <div className="text-primary fw-bold small" style={{ lineHeight: '24px' }}>support@tenorshare.cn</div>
          </div>
        </div>
      </div>
      <header className="header">
        <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container-xl">
            <a className="navbar-brand" href="https://www.niuxuezhang.cn/">
              <svg width="116" height="38" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M43.13 8.07c.83 0 1.5.67 1.5 1.5v1.51c0 .83.69 1.51 1.51 1.51h12.07a1.5 1.5 0 010 3.02H46.14a4.53 4.53 0 01-4.52-4.53v-1.5c0-.84.67-1.51 1.5-1.51zM39.36 21.04c0-.84.67-1.51 1.5-1.51h19.6a1.5 1.5 0 110 3.01h-19.6a1.5 1.5 0 01-1.5-1.5z"
                  fill="#080A1D"></path>
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M50.67 5.43c.83 0 1.5.67 1.5 1.5v24.13a1.5 1.5 0 11-3.01 0V6.94c0-.84.67-1.51 1.5-1.51zM65.75 14.48a3.02 3.02 0 013.01-3.02h16.59a3.02 3.02 0 013.01 3.02v2.26a1.5 1.5 0 11-3.01 0v-2.26H68.76v2.26a1.5 1.5 0 11-3.01 0v-2.26z"
                  fill="#080A1D"></path>
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M71.09 7.61a1.5 1.5 0 011.9.97l.83 2.57a1.5 1.5 0 01-2.87.92l-.83-2.56a1.5 1.5 0 01.97-1.9zM75.76 7.04c.78-.3 1.65.09 1.95.87l1.2 3.16a1.5 1.5 0 01-2.81 1.08l-1.2-3.17c-.3-.78.09-1.65.86-1.94z"
                  fill="#080A1D"></path>
                <path
                  d="M83 6.4a1.5 1.5 0 011 1.88c-.46 1.51-.97 3-1.43 4.52a1.5 1.5 0 01-2.89-.87c.46-1.52.97-3.02 1.44-4.53a1.5 1.5 0 011.88-1z"
                  fill="#080A1D"></path>
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M70.65 17.8c0-.84.67-1.51 1.5-1.51h8.98c.97 0 1.68.6 2.01 1.26.33.66.4 1.63-.25 2.41l-.03.04-3.54 3.75v4.3c0 2.49-2.04 4.52-4.53 4.52h-1.66a1.5 1.5 0 110-3.01h1.66c.83 0 1.51-.69 1.51-1.51v-5.5l3.07-3.25h-7.22a1.5 1.5 0 01-1.5-1.5z"
                  fill="#080A1D"></path>
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M66.5 24.13c0-.84.68-1.51 1.5-1.51h18.1a1.5 1.5 0 110 3.01H68a1.5 1.5 0 01-1.5-1.5zM92.13 19c0-.83.68-1.5 1.51-1.5H114a1.5 1.5 0 010 3H93.64a1.5 1.5 0 01-1.5-1.5z"
                  fill="#080A1D"></path>
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M98.7 5.43c.83 0 1.5.67 1.5 1.5v21.04c0 .83.69 1.51 1.51 1.51h2.26a1.5 1.5 0 110 3.02h-2.26a4.53 4.53 0 01-4.52-4.53V6.94c0-.84.67-1.51 1.5-1.51zM112.23 8.85c.65.52.75 1.47.23 2.12a18.02 18.02 0 01-7.81 5.6 1.5 1.5 0 11-1.05-2.83 15 15 0 006.5-4.65 1.5 1.5 0 012.13-.24z"
                  fill="#080A1D"></path>
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M104.26 18.2a1.5 1.5 0 011.79 1.17c.96 4.52 3.91 8.3 7.89 10.35a1.5 1.5 0 11-1.39 2.68A18.24 18.24 0 01103.1 20a1.5 1.5 0 011.16-1.8z"
                  fill="#080A1D"></path>
                <path d="M28.12 4.36a4.36 4.36 0 11-8.73 0 4.36 4.36 0 018.73 0z" fill="#FFBE37"></path>
                <rect width="8.82" height="38" rx="4.41" fill="#4255FF"></rect>
                <path
                  d="M22 37.51a4.4 4.4 0 004.4-.22 4.5 4.5 0 002.04-3.7V16.58l-8.87-6.49C15.4 6.93 9.9 2.62 6.66.58a4.41 4.41 0 00-4.79.26A4.66 4.66 0 000 4.74v16.2l22 16.57z"
                  fill="#4255FF"></path>
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M8.82 27.6V4.4A4.4 4.4 0 001.87.84 4.66 4.66 0 000 4.74v16.2l8.82 6.65z" fill="#00CAB4">
                </path>
              </svg>
            </a>
            <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent-v1" aria-controls="navbarSupportedContent-v1"
              aria-expanded="false" aria-label="Toggle navigation"> <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent-v1">
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li className="nav-item drop-menu position-relative"> <a className="nav-link">多媒体软件</a>
                  <div className="menu">
                    <div className="py-4 text-wrap">
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div>
                          <img src="https://images.niuxuezhang.cn/imgs/guide/video-enhancer/video-enhancer.png" alt="" className="img-fluid" width="30" />
                        </div> <a href="https://www.niuxuezhang.cn/video-enhancer.html" className="ps-3 small">牛学长视频修复工具</a>
                        <img src="https://images.niuxuezhang.cn/imgs/home/icon_ai.svg" alt="" className="img-fluid ms-1"></img>
                      </div>
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div>
                          <img src="https://images.niuxuezhang.cn/imgs/project/photo_enhancer_icon.svg" alt="" className="img-fluid" width="30" />
                        </div>
                        <a href="https://www.niuxuezhang.cn/photo-enhancer.html" className="ps-3 small">牛学长图片修复工具</a>
                        <img src="https://images.niuxuezhang.cn/imgs/home/icon_ai.svg" alt="" className="img-fluid ms-1" />
                      </div>
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div>
                          <img src="https://images.niuxuezhang.cn/imgs/project/img-92.png" alt="" className="img-fluid" width="30" />
                        </div> 
                        <a href="https://www.niuxuezhang.cn/object-remover.html" className="ps-3 small">牛学长智能抠像工具</a>
                        <img src="https://images.niuxuezhang.cn/imgs/home/icon_ai.svg" alt="" className="img-fluid ms-1" />
                      </div>
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div>
                        <img src="https://images.niuxuezhang.cn/imgs/product-icon/photo-object-remover.png" alt="" className="img-fluid" width="30" />
                        </div>
                        <a href="https://www.niuxuezhang.cn/photo-object-remover.html" className="ps-3 small">牛学长图片消除笔</a>
                        <img src="https://images.niuxuezhang.cn/imgs/home/icon_new.svg" alt="" className="img-fluid ms-1" />
                      </div>
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div>
                          <img src="https://images.niuxuezhang.cn/imgs/howto/video-converter/video_converter_icon.svg" alt="" className="img-fluid" width="30" />
                        </div> <a href="https://www.niuxuezhang.cn/video-converter.html" className="ps-3 small">牛学长转码大师</a>
                      </div>
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div>
                          <img src="https://images.niuxuezhang.cn/imgs/howto/for-screen/phone-mirror-ico.svg" alt="" className="img-fluid" width="30" />
                        </div> <a href="https://www.niuxuezhang.cn/phone-mirror.html" className="ps-3 small">牛学长迅投迅影</a>
                      </div>
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div>
                          <img src="https://images.niuxuezhang.cn/imgs/howto/remove-watermark/remove-watermark_icon.svg" alt="" className="img-fluid" width="30" />
                        </div> <a href="https://www.niuxuezhang.cn/remove-watermark.html" className="ps-3 small">牛学长去水印工具</a>
                      </div>
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div>
                          <img src="https://images.niuxuezhang.cn/imgs/project/img-93.png" alt="" className="img-fluid" width="30" />
                        </div> <a href="https://www.niuxuezhang.cn/screen-recorder.html" className="ps-3 small">牛学长录屏工具</a>
                      </div>
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div>
                          <picture>
                            <img src="https://images.niuxuezhang.cn/imgs/project/img-91.png" alt="" className="img-fluid" width="30" />
                          </picture>
                        </div> <a href="https://www.niuxuezhang.cn/video-editor.html" className="ps-3 small">牛学长视频剪辑软件</a>
                      </div>
                    </div>
                  </div>
                </li>


                
                <li className="nav-item drop-menu position-relative"> <a className="nav-link">在线工具</a>
                  <div className="menu">
                    <div className="py-4 text-wrap">
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div style={{ maxWidth: "30px" }}>
                          <img src="https://images.niuxuezhang.cn/imgs/project/img-10.png" alt="" className="img-fluid" />
                        </div>
                        <a href="https://www.niuxuezhang.cn/online-edit-pdf.html" className="ps-3">牛学长在线PDF编辑</a>
                        <img src="https://images.niuxuezhang.cn/imgs/icon_hot.svg" alt="" className="img-fluid ms-1" />
                      </div>
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div style={{ maxWidth: "30px" }}>
                          <img src="https://images.niuxuezhang.cn/imgs/project/onqsy.png" alt="" className="img-fluid" />
                        </div> <a href="https://www.niuxuezhang.cn/online-photo-watermark-remover.html" className="ps-3">牛学长在线PDF编辑</a>
                        <img src="https://images.niuxuezhang.cn/imgs/home/icon_new.svg" alt="" className="img-fluid ms-1"></img>
                      </div>
                      {/* <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div style={{ maxWidth: "30px" }}>
                          <img src="https://images.niuxuezhang.cn/imgs/ai/ai-tool/aigenius.png" alt="" className="img-fluid" />
                        </div> <a href="https://ai.niuxuezhang.cn/chat" className="ps-3">牛学长在线PDF编辑</a>
                        <img src="https://images.niuxuezhang.cn/imgs/home/icon_new.svg" alt="" className="img-fluid ms-1"></img>
                      </div> */}
                    </div>
                  </div>
                </li>
                {/* <li className="nav-item drop-menu position-relative"> <a className="nav-link">APP</a>
                  <div className="menu">
                    <div className="py-4 text-wrap">
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <div style={{ maxWidth: "30px" }}>
                          <img src="https://images.niuxuezhang.cn/imgs/project/app-icon.png" alt=""
                            className="img-fluid" />
                        </div> <a href="https://www.niuxuezhang.cn/photo-enhancer-app.html"
                          className="ps-3">牛学长图片修复APP</a>
                      </div>
                    </div>
                  </div>
                </li> */}
                <li className="nav-item d-lg-block d-none">
                  <a className="nav-link" href="https://www.niuxuezhang.cn/download-center.html">下载中心</a>
                </li>
                <li className="nav-item drop-menu position-relative">
                  <a className="nav-link" href="https://www.niuxuezhang.cn/store.html">购买中心</a>
                  <div className="menu">
                    <div className="py-4 text-wrap">
                      <div className="d-flex px-4 align-items-center link-color-inherit">
                        <a href="https://www.niuxuezhang.cn/store.html" className="ps-3">单品购买中心</a>
                      </div>
                      <div className="d-flex px-4 align-items-center link-color-inherit position-relative">
                        <a href="https://www.niuxuezhang.cn/store-gift-packs.html" className="ps-3">特惠大礼包在线购买</a>
                        <img src="https://images.niuxuezhang.cn/imgs/home/icon_hot.png" alt="" className="img-fluid ms-1"></img>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="nav-item"> <a className="nav-link" href="https://www.niuxuezhang.cn/how-to.html">专题教程</a> </li>
                <li className="nav-item"> <a className="nav-link" href="https://www.niuxuezhang.cn/support.html">帮助中心</a> </li>
                <li className="nav-item"><a className="nav-link" href="https://www.niuxuezhang.cn/ai-tools-navigation.html">AI导航</a> </li>
              </ul>
              {Cookies.get("authorization") ? (
                <div className='ms-lg-3'>
                  <div className='position-relative' id="person">
                    <img src="https://images.niuxuezhang.cn/imgs/account-center/person.svg" alt="" />
                    <div className='login-out text-center small'>
                      <div className='pb-2 pt-3 border-bottom'> <a href={`${hostname}/account/personal-center/product-list`} style={{ color: '#080A1D', textDecoration: 'none' }} onClick={GAHeaderClickToPersonCenter}>个人中心</a></div>
                      <div className='py-2'><a style={{ color: '#080A1D', textDecoration: 'none' }} onClick={() => { handleLogout(); GAHeaderClickLogout() }}>退出</a></div>
                    </div>
                  </div>
                </div>
              ) : (
                  <div className="ms-lg-3" id="login-btn">
                <a className="btn btn-sm btn-primary rounded-1" href='https://www.niuxuezhang.cn/' onClick={GAHeaderClickLogin}>登录</a>
                <a className="btn btn-sm btn-outline-primary rounded-1 ms-3" href='https://www.niuxuezhang.cn/' onClick={GAHeaderClickSignUp}>注册</a>
                {/* <Link className="btn btn-sm btn-primary rounded-1" to="/login" onClick={GAHeaderClickLogin}>登录</Link>
                <Link className="btn btn-sm btn-outline-primary ms-3 rounded-1" to="/register">注册</Link> */}
              </div>
              )}
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}

export default Header;
